import React from 'react'

function EmailLayout() {
  return (
    <div>
      
    </div>
  )
}

export default EmailLayout
